import Vue from 'vue'
import App from './App.vue'

import Antd from 'ant-design-vue';
import axios from 'axios';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

import { i18n } from './i18n/index'

Vue.config.productionTip = false
Vue.prototype.$axios = axios

new Vue({
  axios,
  i18n,
  render: h => h(App),
}).$mount('#app')
